import React, { useState } from "react";
import PropTypes from "prop-types";
import { Popconfirm as AntPopconfirm } from "antd";
import { UiIcon, UiIconPop } from "./Icon.style";
/**
 * Icon組件
 */

const materialIconType = {
  default: "material-icons",
  outLined: "material-icons-outlined",
  twoTone: "material-icons-two-tone",
  rounded: "material-icons-round",
  sharp: "material-icons-sharp"
};

const Icon = ({
  name,
  type = "default",
  rotate,
  color,
  bgcolor,
  onClick,
  mr,
  disabled,
  clickable = false,
  focus,
  focuscolor
}) => {
  return /*#__PURE__*/React.createElement(UiIcon, {
    rotate: rotate,
    color: disabled ? "#e7e7ed" : color,
    bgcolor: bgcolor,
    focus: focus,
    focuscolor: focuscolor,
    onClick: onClick,
    mr: mr,
    disabled: disabled,
    clickable: clickable
  }, /*#__PURE__*/React.createElement("i", {
    className: materialIconType[type]
  }, name));
};

export const Popconfirm = ({
  name,
  type = "default",
  rotate,
  color,
  bgcolor,
  mr,
  disabled,
  clickable = false,
  icon,
  focuscolor,
  title = "內文唷",
  getPopupContainer = () => document.getElementById("IconPop"),
  onConfirm = () => {}
}) => {
  const [popup, setPopup] = useState(false);

  const onConfirmHandle = () => {
    setPopup(false);
    onConfirm();
  };

  return /*#__PURE__*/React.createElement(UiIconPop, {
    id: "IconPop"
  }, /*#__PURE__*/React.createElement(AntPopconfirm, {
    placement: "bottom",
    title: title,
    icon: icon,
    visible: popup,
    onConfirm: onConfirmHandle,
    onCancel: () => setPopup(false),
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88",
    getPopupContainer: getPopupContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    name: name,
    type: type,
    focus: popup,
    focuscolor: focuscolor,
    rotate: rotate,
    color: disabled ? "#e7e7ed" : color,
    bgcolor: bgcolor,
    onClick: () => setPopup(true),
    mr: mr,
    disabled: disabled,
    clickable: clickable
  })));
};
export default Icon;
Icon.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  rotate: PropTypes.number,
  color: PropTypes.string,
  bgcolor: PropTypes.string,
  onClick: PropTypes.func,
  mr: PropTypes.string,
  disabled: PropTypes.bool,
  clickable: PropTypes.bool,
  focus: PropTypes.bool,
  focuscolor: PropTypes.string
};
Popconfirm.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  rotate: PropTypes.number,
  color: PropTypes.string,
  focuscolor: PropTypes.string,
  bgcolor: PropTypes.string,
  onClick: PropTypes.func,
  mr: PropTypes.string,
  disabled: PropTypes.bool,
  clickable: PropTypes.bool,
  icon: PropTypes.any,
  title: PropTypes.string,
  onConfirm: PropTypes.func,
  getPopupContainer: PropTypes.any
};